// Client-side error reporter. Posts to /api/log-error so failures land in
// Vercel logs alongside server errors. Best-effort: never throws, never
// blocks UI.
import { authHeader } from './api.js';

let installed = false;

export function reportError(payload) {
  // Fire-and-forget. Don't await; don't surface failures (we don't want a
  // log endpoint outage to compound the original error).
  try {
    const body = {
      source: payload.source || 'client',
      phase: payload.phase || null,
      message: payload.message || String(payload.error || 'unknown'),
      stack: payload.stack || payload.error?.stack || null,
      url: typeof window !== 'undefined' ? window.location.href : null,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      extras: payload.extras || null,
    };
    if (typeof fetch !== 'function') return;
    fetch('/api/log-error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeader() },
      body: JSON.stringify(body),
      keepalive: true, // survives unload
    }).catch(() => {});
  } catch {
    /* swallow — never let the reporter itself crash */
  }
}

/**
 * Install global handlers for uncaught errors and unhandled promise rejections.
 * Idempotent — safe to call multiple times.
 */
export function installGlobalErrorHandlers() {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  window.addEventListener('error', (event) => {
    reportError({
      source: 'window.onerror',
      message: event.message,
      stack: event.error?.stack || null,
      extras: { filename: event.filename, lineno: event.lineno, colno: event.colno },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    reportError({
      source: 'unhandledrejection',
      message: reason?.message || String(reason || 'unhandled rejection'),
      stack: reason?.stack || null,
    });
  });
}
